import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getRunningStreamTemplates } from "./actions";

export const streamTemplateEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = streamTemplateEntityAdapter.getInitialState({
  totalCount: 0,
});

export const streamTemplateSlice = createSlice({
  name: "streamTemplate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRunningStreamTemplates.fulfilled, (state, action) => {
      if (action.payload.success) {
        streamTemplateEntityAdapter.setAll(state, action.payload.data);
        state.totalCount = action.payload.templatesCount;
      }
    });
  },
});

export default streamTemplateSlice.reducer;
